<template>

  <div id="app">
    <router-view/>
  </div>

</template>

<script>
export default {
  name: 'App',
  data: {
    scannerCheckInterval: null
  },
  mounted() {
    this.scannerCheckInterval = setInterval(async ()=>{
      if(window.html5QrcodeScanner && (!window.location.href.includes('#/barcode') && !window.location.href.includes('#/qrcode') )){
        console.log(window.html5QrcodeScanner, window.location.href)
        await window.html5QrcodeScanner.clear()
        window.html5QrcodeScanner=null
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.scannerCheckInterval)
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
html {
overflow-x:none;
overflow-y:scroll;
}
body, dl, dt, dd, ul, ol, li, pre, form, fieldset, input, p, blockquote, th, td {
font-weight:900;
margin:0;
padding:0;
}
h1, h2, h3, h4, h4, h5 {
margin:0;
padding:0;
}
body {
background: #f8f8f8;
color:#666666;
/* font-family:Helvetica,Arial,sans-serif; */
font-size:12px;
padding:0 ;
text-align:left ;
}
ol, ul {
list-style-image:none;
list-style-position:outside;
list-style-type:none;
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-weight: 900;
  width: 100%;
  margin: 0 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue